import {
  __toCommonJS,
  init_shared,
  shared_exports
} from "../chunk-XH7JXI3D.mjs";

// camelNamespaces/jsx-runtime.js
var commons = (init_shared(), __toCommonJS(shared_exports));
var namespaceTags = commons.namespaceTags;
var attributeNamespace = {
  "xlinkHref": {
    src: "http://www.w3.org/1999/xlink",
    namespaced: "xlink:href"
  }
};
var appendChild = commons.appendChild;
var Fragment = commons.Fragment;
var handleDangerouslySetInnerHTML = commons.handleDangerouslySetInnerHTML;
var handleRef = commons.handleRef;
var handlePostCreate = commons.handlePostCreate;
function createElement(tag, { children, ...props }, ter, four) {
  const chill = children ? Array.isArray(children) ? children : [children] : [];
  if (typeof tag === "function") {
    if (commons.isClass(tag)) {
      return new tag(arguments[1]);
    } else {
      return tag(arguments[1]);
    }
  }
  const element = tag in namespaceTags ? document.createElementNS(namespaceTags[tag], tag) : document.createElement(tag);
  let postCreate = false;
  Object.entries(props || {}).forEach(([name, value]) => {
    if (name != "children") {
      if (name.startsWith("on") && name.toLowerCase() in window && (typeof value == "function" || typeof value == "string")) {
        element.addEventListener(name.toLowerCase().substr(2), value);
      } else if (name == "dangerouslySetInnerHTML") {
        handleDangerouslySetInnerHTML(element, props);
      } else if (name == "ref") {
        handleRef(element, props);
      } else if (name == "postCreate") {
        postCreate = true;
      } else if (value != void 0) {
        if (name in attributeNamespace) {
          element.setAttributeNS(
            attributeNamespace[name].src,
            attributeNamespace[name].namespaced,
            value.toString()
          );
        } else {
          element.setAttribute(name, value.toString());
        }
      }
    }
  });
  chill.forEach((child) => {
    appendChild(element, child);
  });
  if (postCreate) {
    handlePostCreate(element, props);
  }
  return element;
}
export {
  Fragment,
  createElement as jsx,
  createElement as jsxDEV,
  createElement as jsxs
};
